import React from "react";
import { Card, Button } from "react-bootstrap";

function ProjectCard({ imgPath, title, description, projectLink }) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={imgPath} alt="project-img" />
      <Card.Body>
        <Card.Title>{title}</Card.Title>

        <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
          {description.map((point, index) => (
            <li key={index} style={{ marginBottom: "8px" }}>
              {point}
            </li>
          ))}
        </ul>

        <Button
          variant="primary"
          href={projectLink}
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginTop: "10px" }}
        >
          View Project
        </Button>
      </Card.Body>
    </Card>
  );
}

export default ProjectCard;
